/** Shared flow name constants used across multiple files. */

export const NoConfirmationNewPatientFlowLegacyNames = ["NoConfirmationNewPatientFlow", "newPatient"];
export const NoConfirmationRebookFlowLegacyNames = ["NoConfirmationRebookFlow", "rebook", "NoWelcomeRebookFlow"];
export const NoConfirmationNoBookFlowLegacyNames = ["NoConfirmationNoBookFlow", "noBook", "NoWelcomeNoBookFlow"];
